const systemSettings = {
  pageName: 'Configurações do sistema',
  templatePlaceholder: 'Selecionar modelo',
  templateLabel: 'Modelo de Configurações do Sistema Ativo',
  templateDescriptions: 'Escolha um modelo no menu suspenso acima. O modelo selecionado será aplicado quando você tocar em "Salvar".',
  switchButton: {
    label: 'Visualizar',
    options: {
      site: 'Local',
      account: 'Conta',
    },
  },
  toasts: {
    successfully: 'Salvo com sucesso',
    error: 'Erro',
  },
  toastReset: {
    successfully: 'Restauração para o padrão concluída com sucesso',
    error: 'Falha na restauração para o padrão',
  },
  modalDelete: {
    header: 'Excluir modelo',
    body: 'Você está prestes a excluir um modelo?',
  },
  modalUnsaved: {
    header: 'Mudanças não salvas',
    body: 'As alterações feitas não foram salvas. Deseja continuar sem salvá-los?',
  },
  modalResetSettings: {
    header: 'Restaurar as configurações padrão',
    body: 'Ao continuar, você reverterá para as configurações padrão, resultando na perda de todos os ajustes feitos',
  },
  modalDeleteError: {
    header: 'Excluindo um modelo habilitado para automação',
    body: 'Você está prestes a excluir um modelo vinculado a automações. Para prosseguir com a eliminação, é necessário primeiramente desconectá-lo das automações associadas.',
  }
};

export default systemSettings;
